var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 3c2-3 5-3 6 0l13 27 2 2 30 5c2 0 3 3 1 5L78 64l-1 2 5 31c1 3-2 5-4 3L52 86h-3l-26 14c-3 2-5 0-5-3l5-31-1-2L1 42c-2-2-1-5 2-5l29-5 2-2L47 3Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelIcon);
export default __webpack_public_path__ + "static/media/level-icon.a3a3fe8670ccfb700f86201bfa42e3cb.svg";
export { ForwardRef as ReactComponent };